/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import MaxLengthNumericEditor from '../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';
import {
  currencyFormatter,
  cellStyleFormatter,
  filterFormatter,
  filterUraFormatter,
} from '../../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  getDateInMMDDYYYYFormat,
  quarterComparator,
} from '../../../../../SharedModules/DateUtilities/DateUtilities';
import linksButtonRender from '../linksButtonRender';
import { NumberAndAlphabetComparator } from '../../../../../SharedModules/utilities/utilities';

function monthToComparableNumber(date) {
  if (date === undefined || date === null || date.length !== 10) {
    return null;
  }
  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));
  return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}
function dateComparator(date1, date2) {
  const date1Number = monthToComparableNumber(date1);
  const date2Number = monthToComparableNumber(date2);
  if (date1Number === null && date2Number === null) {
    return 0;
  }
  if (date1Number === null) {
    return -1;
  }
  if (date2Number === null) {
    return 1;
  }
  return date1Number - date2Number;
}
function amountComparator(amount1, amount2) {
  let amt1 = null;
  let amt2 = null;
  if (amount1 && amount1?.toString()?.includes('$')) {
    amt1 = parseFloat(
      amount1?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt1 = parseFloat(amount1?.toString()?.replace(',', '').trim());
  }
  if (amount2 && amount2?.toString()?.includes('$')) {
    amt2 = parseFloat(
      amount2?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt2 = parseFloat(amount2?.toString()?.replace(',', '').trim());
  }
  if (amt1 === null && amt2 === null) {
    return 0;
  }
  if (amt1 === null) {
    return -1;
  }
  if (amt2 === null) {
    return 1;
  }

  return amt1 - amt2;
}
const comparatorQtr = (a, b) => {
  const splittedQtrA = a?.split('Q');
  const splittedQtrB = b?.split('Q');
  return splittedQtrA[1] - splittedQtrB[1] || splittedQtrA[0] - splittedQtrB[0];
};

export const clientTableHead = [
  {
    headerName: 'Client ID',
    field: 'clientId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Client Name',
    field: 'clientName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    resizable: false,
    maxLength: Styles.Length_10,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const rebateProgramTableHead = [
  {
    headerName: 'Rebate Program CD',
    field: 'rebateProgramCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Description',
    field: 'shortDescr',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    resizable: false,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const superClientTableHead = [
  {
    headerName: 'Super Client Name',
    field: 'superClientName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const groupTableHead = [
  {
    headerName: 'Group ID',
    field: 'groupId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Group Name',
    field: 'groupName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    resizable: false,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const groupTableHeadCC = [
  {
    headerName: 'Group ID',
    field: 'groupId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_80,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Group Name',
    field: 'groupName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_80,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    resizable: false,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const contactGroupTableHead = [
  {
    headerName: 'Group ID',
    field: 'groupId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_120,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Group Name',
    field: 'groupName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_120,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Start Date',
    field: 'startDt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_120,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'End Date',
    field: 'endDt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_120,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    resizable: false,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const superClientModalHead = [
  {
    headerName: 'Client ID',
    field: 'clientId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Client Name',
    field: 'clientName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    resizable: false,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const superClientModalHeadCC = [
  {
    headerName: 'Client ID',
    field: 'clientId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_80,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Client Name',
    field: 'clientName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_80,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    resizable: false,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const manuFactureHead = [
  {
    headerName: 'Manufacturer ID',
    field: 'manufacturerId',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      trimInput: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'manufacturerName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    resizable: false,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      trimInput: true,
    },
  },
];
export const invoiceFamilyCells = [
  {
    headerName: 'Actions',
    field: 'actions',
    maxWidth: 150,
    editable: false,
    suppressMenu: false,
    hideFilterIcon: true,
    minWidth: Styles.Width_120,
    sortable: false,
    filter: false,
    cellEditor: MaxLengthNumericEditor,
    cellRendererSelector: (params) => {
      if (params.node.rowPinned) {
        return undefined;
      }
      // rows that are not pinned don't use any cell renderer
      return { component: linksButtonRender };
    },
    cellRenderer: 'LinksButtonRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    pdfExportOptions: {
      skipColumn: true,
    },
  },
  {
    headerName: 'Family Name',
    field: 'familyName',
    editable: false,
    sortable: true,
    columnSpan: 3,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },

  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },

  {
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Drug Name',
    field: 'drugName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 3,
    minWidth: Styles.Width_300,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },

  {
    headerName: 'Qty',
    field: 'totalReimsedUnit',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    isTextColorRed: true,
    // comparator: amountComparator,
    cellRenderer: 'NumOfUnitsCellRender',
    excelAlignment: 'right',
    exportZeroesFour: true,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'URA',
    field: 'unitRebateAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    isTextColorRed: true,
    comparator: amountComparator,
    cellRenderer: 'UnitRebateAmtCellRender',
    excelAlignment: 'right',
    exportZeroesSix: true,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'WAC',
    field: 'wacPrice',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_167,
    isTextColorRed: true,
    comparator: amountComparator,
    cellRenderer: 'AmountComponent',
    cellEditor: MaxLengthNumericEditor,
    exportZeroesTwo: true,
    excelAlignment: 'right',

    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    exportOption: {
      printWithCurrency: '$',
      enableValueFormatter: true,
    },
  },
  {
    headerName: 'Amount Due',
    field: 'amountDue',
    cellRenderer: 'AmountComponent',
    editable: false,
    sortable: true,
    suppressMenu: false,
    exportZeroesTwo: true,
    minWidth: Styles.Width_167,
    isTextColorRed: true,
    comparator: amountComparator,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    exportOption: {
      printWithCurrency: '$',
      enableValueFormatter: true,
    },
  },
];
export const invoiceQuarterCells = [
  {
    headerName: 'Actions',
    field: 'actions',
    exporterSuppressExport: true,
    editable: false,
    suppressMenu: false,
    minWidth: Styles.Width_120,
    hideFilterIcon: true,
    cellClass: 'ag-cell-visible',
    cellEditor: MaxLengthNumericEditor,
    sortable: false,
    filter: false,
    cellRendererSelector: (params) => {
      if (params.node.rowPinned) {
        return undefined;
      }
      // rows that are not pinned don't use any cell renderer
      return { component: linksButtonRender };
    },
    cellStyle: { 'border-right-color': Styles.BorderColor },
    pdfExportOptions: {
      skipColumn: true,
    },
  },
  {
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'nameRenderNdc',
    cellClass: 'frr-ellipsis-text-overlap',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Drug Name',
    field: 'drugName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 3,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'nameRenderDrugName',
    cellClass: 'frr-ellipsis-text-overlap',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },

  {
    headerName: 'URA',
    field: 'unitRebateAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    isTextColorRed: true,
    comparator: amountComparator,
    cellRenderer: 'UnitRebateAmtCellRender',
    exportZeroesSix: true,
    excelAlignment: 'right',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: (params) => cellStyleFormatter(params.data?.unitRebateAmt),
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Total Units Reimbursed',
    field: 'totalReimsedUnit',
    editable: false,
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_200,
    isTextColorRed: true,
    comparator: amountComparator,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'NumOfUnitsCellRender',
    dataAlignRight: true,
    excelAlignment: 'right',
    exportZeroesFour: true,

    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Total Rebate Amt',
    field: 'totalRebateAmt',
    comparator: amountComparator,
    cellRenderer: 'AmountComponent',
    editable: false,
    sortable: true,
    suppressMenu: false,
    isTextColorRed: true,
    autoHeight: true,
    wrapText: true,
    printPrefixValue: '$ ',
    exportZeroesTwo: true,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'Number of Claims',
    field: 'noOfPrescription',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    dataAlignRight: true,
    excelAlignment: 'right',
    comparator: amountComparator,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'State Amt Reimbursed',
    field: 'stateAmtReimbursed',
    wrapHeaderText: true,
    autoHeaderHeight: true,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    isTextColorRed: true,
    cellRenderer: 'AmountComponent',
    comparator: amountComparator,
    exportZeroesTwo: true,

    cellEditor: MaxLengthNumericEditor,
    cellStyle: (params) => cellStyleFormatter(params.data?.stateAmtReimbursed),
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    dataAlignRight: true,
    exportOption: {
      printWithCurrency: '$',
      enableValueFormatter: true,
    },
  },
  {
    headerName: 'Deductible Amt',
    field: 'deductibleAmt',
    cellRenderer: 'AmountComponent',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    isTextColorRed: true,
    comparator: amountComparator,
    exportZeroesTwo: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: (params) => cellStyleFormatter(params.data?.deductibleAmt),
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    dataAlignRight: true,
    exportOption: {
      printWithCurrency: '$',
    },
  },
  {
    headerName: 'TPL Amt',
    field: 'tplAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    isTextColorRed: true,
    cellRenderer: 'AmountComponent',
    comparator: amountComparator,
    exportZeroesTwo: true,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: (params) => cellStyleFormatter(params.data?.tplAmt),
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    dataAlignRight: true,
    exportOption: {
      printWithCurrency: '$',
    },
  },
  {
    headerName: 'Copay Amt',
    field: 'copayAmt',
    cellRenderer: 'AmountComponent',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    isTextColorRed: true,
    comparator: amountComparator,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: (params) => cellStyleFormatter(params.data?.copayAmt),
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    dataAlignRight: true,
    exportOption: {
      printWithCurrency: '$',
    },
  },
  {
    headerName: 'Total Amt Reimbursed',
    field: 'totalReimsedAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    isTextColorRed: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellRenderer: 'AmountComponent',
    comparator: amountComparator,
    resizable: false,
    exportZeroesTwo: true,

    cellEditor: MaxLengthNumericEditor,
    cellStyle: (params) => cellStyleFormatter(params.data?.totalReimsedAmt),
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    dataAlignRight: true,
    exportOption: {
      printWithCurrency: '$',
    },
  },
];
export const invoiceOtherQuarterCells = [
  {
    headerName: 'Actions',
    field: 'actions',
    exporterSuppressExport: true,
    hideFilterIcon: true,
    editable: false,
    suppressMenu: false,
    minWidth: Styles.Width_120,
    cellEditor: MaxLengthNumericEditor,
    sortable: false,
    filter: false,
    cellClass: 'ag-cell-visible',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    cellRendererParams: {
      invoiceOtherQtr: true,
    },
    pdfExportOptions: {
      skipColumn: true,
    },
    cellRendererSelector: (params) => {
      if (params.node.rowPinned) {
        return undefined;
      }
      // rows that are not pinned don't use any cell renderer
      return { component: linksButtonRender };
    },
  },
  {
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'nameRenderOtherNdc',
    cellClass: 'frr-ellipsis-text-overlap',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Drug Name',
    field: 'drugName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    columnSpan: 3,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'nameRenderOtherDrugName',
    cellClass: 'frr-ellipsis-text-overlap',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },

  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },

  {
    headerName: 'Invoice Reason',
    field: 'invoiceReasonCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'NameRenderCheckIssuer',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    cellClass: 'frr-ellipsis-text-overlap',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Current URA',
    field: 'unitRebateAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    isTextColorRed: true,
    cellRenderer: 'CurrentURACellRender',
    dataAlignRight: true,
    excelAlignment: 'right',
    // exportZeroesFour: true,
    comparator: amountComparator,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Current Units',
    field: 'numOfUnits',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    isTextColorRed: true,
    cellRenderer: 'NumOfUnitsCellRender',
    excelAlignment: 'right',
    exportZeroesOne: true,
    comparator: amountComparator,
    cellEditor: MaxLengthNumericEditor,

    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Prior Paid Units',
    field: 'paidUnits',
    editable: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    isTextColorRed: true,
    cellRenderer: 'NumOfUnitsCellRender',
    dataAlignRight: true,
    excelAlignment: 'right',
    exportZeroesOne: true,
    comparator: amountComparator,
    cellEditor: MaxLengthNumericEditor,

    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Prior Disputed Units',
    field: 'disputedUnits',
    editable: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    isTextColorRed: true,
    cellRenderer: 'NumOfUnitsCellRender',
    dataAlignRight: true,
    excelAlignment: 'right',
    exportZeroesOne: true,
    comparator: amountComparator,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Original Invoiced Amt',
    field: 'origInvAmt',
    cellRenderer: 'AmountComponent',
    editable: false,
    // wrapHeaderText: true,
    autoHeaderHeight: true,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    isTextColorRed: true,
    comparator: amountComparator,
    exportZeroesTwo: true,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: (params) => cellStyleFormatter(params.data?.origInvAmt),
    filter: 'agTextColumnFilter',
    printPrefixValue: '$ ',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    exportOption: {
      printWithCurrency: '$',
    },
  },
  {
    headerName: 'Revised Invoiced Amt',
    field: 'revisedInvAmt',
    cellRenderer: 'AmountComponent',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    isTextColorRed: true,
    comparator: amountComparator,
    exportZeroesTwo: true,
    // wrapHeaderText: true,
    autoHeaderHeight: true,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: (params) => cellStyleFormatter(params.data?.revisedInvAmt),
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    isAmount: true,
    printPrefixValue: '$ ',
    exportOption: {
      printWithCurrency: '$',
    },
  },
  {
    headerName: 'Prior Paid Amt',
    field: 'priorPaidAmt',
    cellRenderer: 'AmountComponent',
    editable: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    isTextColorRed: true,
    comparator: amountComparator,
    exportZeroesTwo: true,

    cellEditor: MaxLengthNumericEditor,
    cellStyle: (params) => cellStyleFormatter(params.data?.priorPaidAmt),
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    printPrefixValue: '$ ',
    exportOption: {
      printWithCurrency: '$',
    },
  },

  {
    headerName: 'Principal Due',
    field: 'principleDue',
    cellRenderer: 'AmountComponent',
    comparator: amountComparator,
    editable: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    sortable: true,
    suppressMenu: false,
    isTextColorRed: true,
    autoHeight: true,
    wrapText: true,
    printPrefixValue: '$ ',
    exportZeroesTwo: true,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Interest Due',
    field: 'interestCalculatedAmt',
    cellRenderer: 'AmountComponent',
    editable: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    isTextColorRed: true,
    comparator: amountComparator,
    exportZeroesTwo: true,

    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    isAmount: true,

    exportOption: {
      printWithCurrency: '$',
    },
  },
  {
    headerName: 'Total Due',
    field: 'totalDue',
    cellRenderer: 'AmountComponent',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    isTextColorRed: true,
    autoHeight: true,
    wrapText: true,
    printPrefixValue: '$ ',
    exportZeroesTwo: true,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
      display: 'inline',
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
export const invoiceQuarterTotalsCells = [
  {
    headerName: 'Quarter',
    field: 'prevQtr',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_130,
    comparator: comparatorQtr,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Original Invoiced Amt',
    field: 'ctotOrigInvAmt',
    cellRenderer: 'AmountComponent',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_220,
    isTextColorRed: true,
    comparator: amountComparator,
    exportZeroesTwo: true,
    // wrapHeaderText: true,
    autoHeaderHeight: true,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    dataAlignRight: true,
    exportOption: {
      printWithCurrency: '$',
    },
  },
  {
    headerName: 'Revised Invoiced Amt',
    field: 'ctotRevInvAmt',
    cellRenderer: 'AmountComponent',
    editable: false,
    sortable: true,
    // wrapHeaderText: true,
    autoHeaderHeight: true,
    suppressMenu: false,
    minWidth: Styles.Width_220,
    isTextColorRed: true,
    comparator: amountComparator,
    exportZeroesTwo: true,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    dataAlignRight: true,
    exportOption: {
      printWithCurrency: '$',
    },
  },

  {
    headerName: 'Prior Paid Amt',
    field: 'ctotPpAmt',
    cellRenderer: 'AmountComponent',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,

    isTextColorRed: true,
    autoHeight: true,
    wrapText: true,
    printPrefixValue: '$ ',
    exportZeroesTwo: true,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Principal Due',
    field: 'ctotPrincipalDue',
    cellRenderer: 'AmountComponent',
    comparator: amountComparator,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    editable: false,
    sortable: true,
    suppressMenu: false,
    isTextColorRed: true,
    autoHeight: true,
    wrapText: true,
    printPrefixValue: '$ ',
    exportZeroesTwo: true,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'Interest Due',
    field: 'ctotIntDue',
    cellRenderer: 'AmountComponent',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    isTextColorRed: true,
    autoHeight: true,
    wrapText: true,
    printPrefixValue: '$ ',
    exportZeroesTwo: true,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Total Due',
    field: 'ctotTotalDue',
    cellRenderer: 'AmountComponent',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    isTextColorRed: true,
    autoHeight: true,
    wrapText: true,
    printPrefixValue: '$ ',
    exportZeroesTwo: true,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
export const invoiceDrugActivityCells = [
  {
    headerName: 'Activity Type',
    field: 'drugActivityTypeCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'DrugActivityTypeCdCellRender',
    cellClass: 'frr-ellipsis-text',
    minWidth: Styles.Width_250,
    columnSpan: 2,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },

  {
    headerName: 'Activity Date',
    field: 'drugActivityDt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Effective Quarter',
    field: 'invoiceQtr',
    editable: false,
    sortable: true,
    suppressMenu: false,
    comparator: quarterComparator,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'URA',
    field: 'unitRebateAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    isTextColorRed: true,
    comparator: amountComparator,
    cellRenderer: 'UnitRebateAmtCellRender',
    dataAlignRight: true,
    excelAlignment: 'right',
    exportZeroesSix: true,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Number of Units',
    field: 'numOfUnits',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    isTextColorRed: true,
    exportZeroesFour: true,
    excelAlignment: 'right',
    comparator: amountComparator,
    cellRenderer: 'NumOfUnitsCellRender',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Change of Units',
    field: 'changeNumOfUnits',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'ChangeNumOfUnitsCellRender',
    isTextColorRed: true,
    comparator: amountComparator,
    minWidth: Styles.Width_200,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    exportZeroesTwo: true,
    excelAlignment: 'right',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'Dispute Code',
    field: 'disputeCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    columnSpan: 2,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },

  {
    headerName: 'Dollar Amt',
    field: 'changeAmt',
    cellRenderer: 'AmountComponent',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    resizable: false,
    printPrefixValue: '$ ',
    isTextColorRed: true,
    exportZeroesTwo: true,
    comparator: amountComparator,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const invoiceChecksLogCells = [
  {
    headerName: 'Check Log Number',
    field: 'checkLogNum',
    sort: 'asc',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    excelAlignment: 'right',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Batch Number',
    field: 'batchNum',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellClass: 'frr-ellipsis-text',
    cellRenderer: 'NameRenderBatchNum',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Batch Date',
    field: 'batchDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_130,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Number',
    field: 'checkNum',
    editable: false,
    sortable: true,
    autoHeight: true,
    wrapText: true,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Issuer',
    field: 'checkIssuer',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 3,
    minWidth: Styles.Width_280,
    cellEditor: MaxLengthNumericEditor,
    cellClass: 'frr-ellipsis-text',
    cellRenderer: 'NameRenderCheckIssuer',
    comparator: NumberAndAlphabetComparator,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Information',
    field: 'checkInfo',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 3,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellClass: 'frr-ellipsis-text',

    cellRenderer: 'NameRenderInformation',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Check Date',
    field: 'checkDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_130,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Postmark Date',
    field: 'postmarkedDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Received Date',
    field: 'receivedDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Amt',
    field: 'checkAmt',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    isTextColorRed: true,
    autoHeight: true,
    wrapText: true,
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'CheckAmtCellRender',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Format',
    field: 'invRecFormatCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_120,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Dispute Resolution',
    field: 'disputeResolutionCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    autoHeight: true,
    wrapText: true,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Payee',
    field: 'checkPayeeCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    autoHeight: true,
    wrapText: true,
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Allocated Amt',
    field: 'totAllocatedAmt',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    isTextColorRed: true,
    autoHeight: true,
    resizable: false,

    wrapText: true,
    minWidth: Styles.Width_210,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'TotAllocatedAmtCellRender',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const clientGroupPlanHead = [
  {
    headerName: 'Client/Group/Plan',
    field: 'planId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_80,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Plan Name',
    field: 'planName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_80,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    resizable: false,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const contractTableHead = [
  {
    headerName: 'Contract ID',
    field: 'contractNum',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_80,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Contract Name',
    field: 'contractName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_80,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    resizable: false,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const manuFactureChildHead = [
  {
    headerName: 'Type',
    field: 'keyTypeCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_80,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Contact Name',
    field: 'contactName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_80,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Corp Name',
    field: 'corpName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_80,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    resizable: false,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
